"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultProps = exports.VERTICAL_SPACING = exports.MARKER_EXAMPLE_SIZE = void 0;
var VERTICAL_SPACING = 'S200';
exports.VERTICAL_SPACING = VERTICAL_SPACING;
var MARKER_EXAMPLE_SIZE = 16;
exports.MARKER_EXAMPLE_SIZE = MARKER_EXAMPLE_SIZE;
var defaultProps = {
  markers: []
};
exports.defaultProps = defaultProps;